'use client';

import cn from 'clsx';
import Image from 'next/image';
import { type ReactNode, useState } from 'react';

type ImageLoaderProps = {
  src: string;
  alt: string;
  divStyle: string;
  children?: ReactNode;
  objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
  draggable?: boolean;
  imageStyle?: string;
  noPlaceholder?: boolean;
  onClick?: () => void;
};

export function ImageLoader({
  src,
  alt,
  divStyle,
  children,
  objectFit,
  draggable,
  imageStyle,
  noPlaceholder,
  onClick,
}: ImageLoaderProps) {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoad = (): void => setIsLoading(false);

  return (
    <div className={cn('relative', divStyle, !noPlaceholder && isLoading && 'animate-pulse !bg-primary')}>
      <Image
        className={cn(imageStyle, onClick && 'cursor-pointer transition')}
        src={src}
        alt={alt}
        draggable={draggable}
        objectFit={objectFit}
        layout='fill'
        onLoadingComplete={!noPlaceholder ? handleLoad : undefined}
        onClick={onClick}
      />
      {children}
    </div>
  );
}
